import React, { Dispatch, SetStateAction } from "react";
import logo from "../../Assets/Images/watermark_logo.svg";
import "../../Assets/Styles/pages/header.scss";
import menuBurger from "../../Assets/Images/menuBurger.svg";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import Slide from "@material-ui/core/Slide";
import { useSwipeable } from "react-swipeable";

export interface HeaderMobileViewProps {
  handlePage: (page: string) => void;
  handleMenuToggle: () => void;
  setIsMenuOpen: (value: boolean) => void;
  isMenuOpen: boolean;
  setOpenSettings: Dispatch<SetStateAction<boolean>>;
  setOpenSignIn: Dispatch<SetStateAction<boolean>>;
}

function HeaderMobileView({
  handlePage,
  handleMenuToggle,
  setIsMenuOpen,
  isMenuOpen,
  setOpenSettings: _setOpenSettings,
  setOpenSignIn: _setOpenSignIn,
}: HeaderMobileViewProps) {
  const { t } = useTranslation();
  const handlers = useSwipeable({
    onSwipedRight: () => setIsMenuOpen(false),
  });

  return (
    <>
      <Row className="m-0 bg-white">
        <Row className="w-100 border-bottom ">
          <Col className="d-flex justify-content-center">
            <Col
              xs={3}
              sm={2}
              className="d-flex justify-content-center align-items-center"
            >
              <img
                alt="logo"
                onClick={() => handlePage("/")}
                src={logo}
                className="m-2 logo"
              />
            </Col>
            <Col className="d-flex justify-content-start align-items-center TREBUCBD text_22 ms-3 logo_text m-0 p-0">
              {t("lang.ezywatermark")}
            </Col>
          </Col>
          <Col className="d-flex justify-content-end align-items-center m-0 p-0">
            <img
              alt="hamburger"
              src={menuBurger}
              className={`mobile-menu-icon icon1 ${
                isMenuOpen ? "icon1Open" : "icon1Close"
              }  m-0 p-0`}
              onClick={handleMenuToggle}
            />
          </Col>
        </Row>
        <Slide
          direction="left"
          in={isMenuOpen}
          mountOnEnter
          unmountOnExit
          timeout={500}
        >
          <Row {...handlers} className="menu m-0 p-0 bg-white">
            <Col className="  productSans line_height_100pc justify-content-center align-items-center">
              <Row className="ps-5 py-4 border-bottom p-0">
                <p
                  onClick={() => {
                    setIsMenuOpen(false);
                    handlePage("/");
                  }}
                  className="button_text  text_16 ms-5 m-0 p-0 d-flex align-items-center "
                >
                  {t("Home")}
                </p>
              </Row>
              <Row className="ps-5 py-4 border-bottom p-0">
                <p
                  onClick={() => handlePage("/features")}
                  className="button_text text_16 ms-5 m-0 p-0 d-flex align-items-center "
                >
                  {t("Features")}
                </p>
              </Row>
              {/* <Row className="ps-5 py-4 border-bottom p-0">
                <p
                  onClick={() => handlePage("/faq")}
                  className='button_text ms-5 m-0 p-0 d-flex align-items-center ' >{t("FAQ")}</p>
              </Row> */}
              <Row className="ps-5 py-4 border-bottom p-0">
                <p
                  onClick={() => handlePage("/pricing")}
                  className="button_text text_16 ms-5 m-0 p-0 d-flex align-items-center "
                >
                  {t("Pricing")}
                </p>
              </Row>
              <Row className="ps-5 py-4 p-0">
                <p className="button_text text_16 ms-5 m-0 p-0 d-flex align-items-center ">
                  {t("Blogs")}
                </p>
              </Row>
            </Col>
          </Row>
        </Slide>
      </Row>
    </>
  );
}
export default HeaderMobileView;
